/* eslint-disable max-len */
const React = require('react');
const { Dark, Default, Flat, Bootstrap } = require('./Images/Themes');
const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');
const { CountryOfOperationItems } = require('../utils/constants');

const defaultAdvancedColorsOptions = {
  textPrimaryColor: '',
  textSecondaryColor: '',
  inputBackgroundColor: '',
  formBackgroundColor: '',
  baseColor: '',
  baseColorFirstVariant: '',
  baseColorSecondVariant: '',
  errorColor: '',
  successColor: '',
  outlinePrimaryColor: '',
  outlineSecondaryColor: '',
  buttonTextColor: '',
  fontSizeExtraSmall: '',
  fontSizeSmall: '',
  fontSizeMedium: '',
  fontSizeLarge: '',
  fontSizeExtraLarge: '',
  fontWeightNormal: '',
  fontWeightSemiBold: '',
  formInputsTextTransform: '',
  inputVerticalPadding: '',
  inputHorizontalPadding: '',
  inputFocusedBoxShadow: '',
  inputErrorFocusedBoxShadow: '',
  inputBorderWidth: '',
  inputFocusedBorderWidth: '',
  borderRadiusSmall: '',
  borderRadiusMedium: '',
  borderRadiusLarge: '',
  borderRadiusFull: '',
  formPadding: '',
};

const defaultAdvancedTextOptions = {
  formTitle: '',
  emailSectionTitle: '',
  installmentsSectionTitle: '',
  cardholderName: {
    label: '',
    placeholder: '',
  },
  email: {
    label: '',
    placeholder: '',
  },
  cardholderIdentification: {
    label: '',
  },
  cardNumber: {
    label: '',
  },
  expirationDate: {
    label: '',
  },
  securityCode: {
    label: '',
  },
  selectInstallments: '',
  selectIssuerBank: '',
  formSubmit: '',
};

const defaultInitializationOptions = {
  firstName: '',
  lastName: '',
  identification: {
    type: '',
    number: '',
  },
  email: '',
  address: {
    zipCode: '',
    federalUnit: '',
    city: '',
    neighborhood: '',
    streetName: '',
    streetNumber: '',
    complement: '',
  },
};

function componentProps(i18n, lang) {
  return {
    title: i18n.gettext('Payment Brick'),
    description: i18n.gettext('Construye y comprueba la experiencia visual en tiempo real. Cuando esté todo listo, descarga o copia el código generado para agregarlo a tu sitio web o compartirlo con un desarrollador.'),
    breadCrumbLevels: [
      {
        text: i18n.gettext('Documentación'),
        id: '1',
        href: `/developers/${lang}/docs`,
      },
      {
        text: i18n.gettext('Checkout Bricks'),
        id: '2',
        href: `/developers/${lang}/docs/checkout-bricks/landing`,
      },
      {
        text: i18n.gettext('Payment Brick'),
        id: '3',
        href: `/developers/${lang}/docs/checkout-bricks/payment-brick/introduction`,
      },
      {
        text: i18n.gettext('Demostración'),
        id: '4',
        disabled: true,
      },
    ],
    publicKey: 'APP_USR-7355677e-d3ce-43d8-89bf-99a4c74718ca',
    optionsDescription: i18n.gettext('Configuración básica'),
    mobileDescription: i18n.gettext('Ingresa a la Demostración en una computadora para hacer configuraciones más avanzadas y tener acceso al código generado.'),
    languages: [
      {
        description: i18n.gettext('Português'),
        value: 'pt',
      },
      {
        description: i18n.gettext('Español'),
        value: 'es',
      },
      {
        description: i18n.gettext('English'),
        value: 'en',
      },
    ],
    options: [
      {
        id: 'publicKey',
        type: 'dropdown',
        label: i18n.gettext('País de operación'),
        placeholder: i18n.gettext('País de operación'),
        trackingLabel: 'COUNTRY_OF_OPERATION',
        items: CountryOfOperationItems.getJsxItems(i18n),
        width: 'full',
      },
      {
        id: 'theme',
        type: 'dropdown',
        label: i18n.gettext('Tema'),
        placeholder: i18n.gettext('Tema'),
        trackingLabel: 'THEME',
        defaultValue: 'default',
        items: [
          { value: 'default', primary: i18n.gettext('Default'), icon: <Default /> },
          { value: 'dark', primary: i18n.gettext('Dark'), icon: <Dark /> },
          { value: 'bootstrap', primary: i18n.gettext('Bootstrap'), icon: <Bootstrap /> },
          { value: 'flat', primary: i18n.gettext('Flat'), icon: <Flat /> },
        ],
        width: 'full',
      },
      {
        id: 'amount',
        type: 'textfield',
        label: i18n.gettext('Monto total a pagar'),
        placeholder: i18n.gettext('Monto total a pagar'),
        trackingLabel: 'AMOUNT',
        defaultValue: '10000',
        width: 'full',
        tooltipContent: i18n.gettext('Esta customización no impacta el layout y solo se refleja en el código.'),
      },
      {
        id: 'paymentMethodLabel',
        type: 'label',
        label: i18n.gettext('Medios de pago'),
        style: {
          marginBottom: '0px !important',
        },
      },
      {
        id: 'paymentMethod',
        type: 'checkboxList',
        label: i18n.gettext('Medios de pago'),
        width: 'full',
        defaultValue: ['creditCard', 'debitCard', 'ticket', 'bankTransfer', 'atm', 'onboarding_credits', 'wallet_purchase'],
        trackingLabel: 'PAYMENT_METHODS',
        required: {
          message: i18n.gettext('Debes seleccionar, al menos, un medio de pago.'),
        },
        items: [
          { id: 'creditCard',
            value: 'creditCard',
            title: i18n.gettext('Tarjeta de Crédito') },
          { id: 'debitCard',
            value: 'debitCard',
            title: i18n.gettext('Tarjeta de Débito') },
          { id: 'ticket',
            value: 'ticket',
            title: i18n.gettext('Efectivo'),
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: [
                  'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA
                  'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB
                  'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM
                  'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', // MLU
                  'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO
                  'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE
                ],
              },
            ] },
          { id: 'bankTransfer',
            value: 'bankTransfer',
            title: i18n.gettext('Transferencia bancaria'),
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: [
                  'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB
                  'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM
                  'TEST-af696d89-c335-4cc1-982c-af28f38e7894', // MCO
                  'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', // MLC
                ],
              },
            ] },
          { id: 'atm',
            value: 'atm',
            title: i18n.gettext('Transferencia bancaria'),
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', // MPE,
              },
            ] },
          { id: 'onboarding_credits',
            value: 'onboarding_credits',
            title: i18n.gettext('Cuotas sin Tarjeta de Mercado Pago'),
            conditionalRender: [
              {
                inputId: 'publicKey',
                expectedValue: [
                  'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', // MLB
                  'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', // MLM
                  'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', // MLA
                ],
              },
            ],
          },
          { id: 'wallet_purchase',
            value: 'wallet_purchase',
            title: i18n.gettext('Mercado Pago Wallet'),
          },
        ],
      },
      {
        id: 'installments',
        type: 'dropdown',
        label: i18n.gettext('Número máximo de cuotas'),
        placeholder: i18n.gettext('Número máximo de cuotas'),
        message: i18n.gettext('Válido solo para pagos con tarjeta de crédito'),
        trackingLabel: 'MAXIMUM_NUMBER_OF_INSTALLMENTS',
        defaultValue: '1',
        width: 'full',
        items: [
          { value: '1', primary: `1 ${i18n.gettext('cuota')}` },
          { value: '2', primary: `2 ${i18n.gettext('cuotas')}` },
          { value: '3', primary: `3 ${i18n.gettext('cuotas')}` },
          { value: '4', primary: `4 ${i18n.gettext('cuotas')}` },
          { value: '5', primary: `5 ${i18n.gettext('cuotas')}` },
          { value: '6', primary: `6 ${i18n.gettext('cuotas')}` },
          { value: '7', primary: `7 ${i18n.gettext('cuotas')}` },
          { value: '8', primary: `8 ${i18n.gettext('cuotas')}` },
          { value: '9', primary: `9 ${i18n.gettext('cuotas')}` },
          { value: '10', primary: `10 ${i18n.gettext('cuotas')}` },
          { value: '11', primary: `11 ${i18n.gettext('cuotas')}` },
          { value: '12', primary: `12 ${i18n.gettext('cuotas')}` },
        ],
        conditionalRender: [
          {
            inputId: 'paymentMethod',
            expectedValue: [
              'creditCard',
              'onboarding_credits',
              'wallet_purchase',
            ],
          },
        ],
      },
      {
        id: 'switchLabel',
        type: 'label',
        label: i18n.gettext('Mostrar en el layout'),
      },
      {
        id: 'showTitle',
        type: 'switch',
        trackingLabel: 'TITLE',
        label: i18n.gettext('Título'),
        width: 'full',
        defaultValue: true,
        checked: true,
      },
      {
        id: 'showPaymentButton',
        type: 'switch',
        trackingLabel: 'PAYMENT_BUTTON',
        label: i18n.gettext('Botón de pagar'),
        width: 'full',
        defaultValue: true,
        checked: true,
        tooltipContent: i18n.jsx.gettext('Asegúrate que el layout de tu sitio tenga un botón para hacer pago antes de personalizar tu Brick.{0}{1}Más información en la documentación{2}', {
          tags: {
            0: '<br><br>',
            1: `<a href="/developers/${lang}/docs/checkout-bricks/payment-brick/additional-customization/hide-element" rel="noopener noreferrer" target="_blank">`,
            2: '</a>',
          },
        }),
      },
    ],
    advancedOptionsDescription: i18n.gettext('Configuraciones avanzadas'),
    advancedOptions: [
      {
        id: 'customVariables',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Personaliza las variables'),
        linkDescription: i18n.gettext('Más información'),
        linkUrl: 'docs/checkout-bricks/additional-content/modify-css-variables',
        defaultValue: JSON.stringify(
          defaultAdvancedColorsOptions,
          null,
          2,
        ),
      },
      {
        id: 'customTexts',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Cambiar textos'),
        linkDescription: i18n.gettext('Más información'),
        linkUrl: 'docs/checkout-bricks/payment-brick/visual-customizations/change-texts',
        defaultValue: JSON.stringify(
          defaultAdvancedTextOptions,
          null,
          2,
        ),
      },
      {
        id: 'payerInfo',
        type: 'textfield',
        width: 'full',
        rows: 13,
        isCode: true,
        label: i18n.gettext('Configurar inicialización del Payment'),
        linkDescription: i18n.gettext('Más información'),
        linkUrl: 'docs/checkout-bricks/payment-brick/advanced-features/initialize-data-on-the-bricks',
        defaultValue: JSON.stringify(
          defaultInitializationOptions,
          null,
          2,
        ),
      },
    ],
  };
}

function getProps(i18n, lang) {
  return componentProps(i18n, lang);
}

module.exports = { getProps, defaultAdvancedColorsOptions, defaultAdvancedTextOptions, defaultInitializationOptions };
